import React from 'react'
import DateFilter from './DateFilter'

const PageFilters = ({ startDate, endDate }) => (
    <div
        className="row wrapper border-bottom white-bg page-heading"
        style={{ padding: '5px 10px' }}
    >
        <div className="col-lg-12">
            <div className="flex jc-start">
                <h4 style={{ margin: '0px 20px 0px 0px' }}>Filters:</h4>
                <DateFilter startDate={startDate} endDate={endDate} />
            </div>
        </div>
    </div>
)

export default PageFilters
